import { createSlice } from "@reduxjs/toolkit";

export interface ResponseError {
  message: string;
}

const initialState: {display: boolean} = {
  display: false
};

const UserSessionMessageSlice = createSlice({
  name: "UserSessionMessageSlice",
  initialState,
  reducers: {
    resetUseSessionMessage: () => {
      return initialState;
    },
    showUserSessionMessage: () => {
        return {display: true};  
    }
  },
});

export const { resetUseSessionMessage, showUserSessionMessage } = UserSessionMessageSlice.actions;

export default UserSessionMessageSlice.reducer;
